import React from 'react'

export const getLayoutWithSideNav = (SideNav) => (page) => (
  <SideNav>{page}</SideNav>
)
